import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

export const commissionRateSchema = yup.object({
	cancelFeeCommissionRate: yup
		.number()
		.typeError("数値を入力してください")
		.required("キャンセル料回収手数料率は必須です")
		.integer("整数で入力してください")
		.min(0, "0以上で入力してください")
		.max(100, "100以下で入力してください"),
	// 既存客用（分離 OFF のときは全顧客共通の再予約手数料率としても使う）
	existingCustomerRereservationCommissionRate: yup
		.number()
		.typeError("数値を入力してください")
		.required("再予約手数料率は必須です")
		.integer("整数で入力してください")
		.min(0, "0以上で入力してください")
		.max(100, "100以下で入力してください"),
	// 新規客に別の手数料率を設定するか（UI トグル。API には送らない）
	isSplitNewCustomerRate: yup.boolean().required(),
	// 新規客用（分離 ON のときのみ必須。OFF のときは送信時に既存客用と同値にする）
	newCustomerRereservationCommissionRate: yup
		.number()
		.when("isSplitNewCustomerRate", {
			is: true,
			then: (schema) =>
				schema
					.typeError("数値を入力してください")
					.required("新規顧客用再予約手数料率は必須です")
					.integer("整数で入力してください")
					.min(0, "0以上で入力してください")
					.max(100, "100以下で入力してください"),
			otherwise: (schema) => schema.transform(() => undefined).notRequired(),
		}),
})

export type CommissionRateFormData = yup.InferType<typeof commissionRateSchema>

export const commissionRateResolver = yupResolver(commissionRateSchema)
